import styled from 'styled-components'

import { getBrandingColor } from 'utils/branding'

export const StyledInjuriesIcon = styled.div`
  .injuriesPathWithPrimaryColor {
    fill: ${getBrandingColor('primary-color')};
  }
`
